import TrashIcon from "../../Icons/TrashIcon";
import { DeleteStudent } from "../../../api/Students/DeleteCourse";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import DeleteModal from "../../Shared/DeleteModal";
import { DoorOpenIcon } from "lucide-react";
import { Switch } from "@headlessui/react";
import { UpdateUserBlockedData } from "../../../api/Students/UpdateUserBlockedData";
import { EnableIpException, DisableIpException } from "../../../api/Students/UpdateIpException";
const StudentsRow = ({
  id,
  fullName,
  email,
  joinedAt,
  phone,
  country,
  studentId,
  img,
  status,
  lastCountry,
  jobTitle,
  birthDate,
  lastVisited,
  isBlocked = false,
  ipRestrictionException = false,
}: {
  id: string;
  fullName: string;
  email: string;
  joinedAt: string;
  phone: string;
  country: string;
  studentId: string;
  img: string;
  status: string;
  lastCountry: string | null;
  jobTitle: string;
  birthDate: string;
  lastVisited: string;
  isBlocked: boolean;
  ipRestrictionException: boolean;
}) => {
  const handleDelete = async (id: string) => {
    await DeleteStudent(id);
    toast.success("Student deleted successfully");
  };

  const [isBlockedUser, setIsBlockedUser] = useState(false);
  const [ipException, setIpException] = useState(false);
  useEffect(() => {
    setIsBlockedUser(isBlocked);
  }, [isBlocked]);
  useEffect(() => {
    setIpException(ipRestrictionException);
  }, [ipRestrictionException]);
  const [isOpen, setIsOpen] = useState(false);

  const handleBlockedToggle = async () => {
    const update = await UpdateUserBlockedData(id);
    if (!update.error) {
      setIsBlockedUser((prev) => !prev);
    }
  };

  const handleIpExceptionToggle = async () => {
    const result = ipException
      ? await DisableIpException(id)
      : await EnableIpException(id);
    if (!result.error) {
      setIpException((prev) => !prev);
    }
  };

  return (
    <>
      <tr>
        <Link className="w-full" to={`/dashboard/students/${studentId}`}>
          <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
            <div className="inline-fl rounded-full text-left py-0.5 text-sm font-semibold flex items-center gap-4">
              <img className="w-11 h-11 rounded-full object-cover" src={img} />
              {fullName}
            </div>
          </td>
        </Link>
        <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
            {email}
          </div>
        </td>
        <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
            {country}
          </div>
        </td>
        <td className=" px-2 first:pl-5 text-center last:pr-5  py-3 whitespace-nowrap">
          <div className="inline-flex  rounded-full py-0.5 text-sm font-semibold">
            {lastCountry}
          </div>
        </td>
        <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
            {lastVisited}
          </div>
        </td>

        <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
            {joinedAt}
          </div>
        </td>
        <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
            {phone}
          </div>
        </td>
        <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
            {jobTitle}
          </div>
        </td>
        <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
            {birthDate}
          </div>
        </td>

        <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <div
            className={`capitalize inline-flex rounded-full text-left py-0.5 text-sm font-semibold ${
              status === "active" ? "text-green-500" : "text-red-500"
            }`}
          >
            {status}
          </div>
        </td>

        <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <Switch
            checked={isBlockedUser}
            onChange={handleBlockedToggle}
            className={`${isBlockedUser ? "bg-secondary" : "bg-primary"}
          relative inline-flex h-[38px] w-[74px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white/75`}
          >
            <span
              aria-hidden="true"
              className={`${isBlockedUser ? "translate-x-9" : "translate-x-0"}
            pointer-events-none inline-block h-[34px] w-[34px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
            />
          </Switch>
        </td>
        <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <Switch
            checked={ipException}
            onChange={handleIpExceptionToggle}
            className={`${ipException ? "bg-secondary" : "bg-primary"}
          relative inline-flex h-[38px] w-[74px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white/75`}
          >
            <span
              aria-hidden="true"
              className={`${ipException ? "translate-x-9" : "translate-x-0"}
            pointer-events-none inline-block h-[34px] w-[34px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
            />
          </Switch>
        </td>
        <td className="px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
          <div className="flex justify-center items-stretch gap-3">
            <div className="flex flex-shrink-0 rounded-xl justify-center items-center border p-3 text-sm font-semibold">
              <Link to={`/dashboard/student-attemps/${studentId}`}>
                <DoorOpenIcon />
              </Link>
            </div>
            <div className="flex flex-shrink-0 rounded-xl justify-center items-center border p-3 text-sm font-semibold">
              <button onClick={() => setIsOpen(true)}>
                <TrashIcon />
              </button>
            </div>
          </div>
        </td>
      </tr>

      <DeleteModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        mutationFn={handleDelete}
        itemId={studentId}
        queryKey="students"
      />
    </>
  );
};

export default StudentsRow;
